import type { StoredTeamRole } from '../../../hooks/types';
import type { RecordStatus } from '../types';

/**
 * Filter team roles based on their record status.
 * @param teamRoles array of team roles to be filtered.
 * @param status target record status.
 * @returns array of team roles with target record status.
 */
export const teamRolesByStatus = (
  teamRoles: readonly StoredTeamRole[] | undefined,
  status: RecordStatus
) => teamRoles?.filter((teamRole) => teamRole.record_status === status) ?? [];
